const TRADING_SESSION_USER_KEY = 'octopus:trading-session-user';

export function isTradingSessionBootstrapped(userId: string): boolean {
  try {
    return sessionStorage.getItem(TRADING_SESSION_USER_KEY) === userId;
  } catch {
    return false;
  }
}

export function markTradingSessionBootstrapped(userId: string): void {
  try {
    sessionStorage.setItem(TRADING_SESSION_USER_KEY, userId);
  } catch {
    /* sessionStorage unavailable */
  }
}

export function clearTradingSessionBootstrap(): void {
  try {
    sessionStorage.removeItem(TRADING_SESSION_USER_KEY);
  } catch {
    /* sessionStorage unavailable */
  }
}
